var _metadata, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M195.4,77.4h-33.7v8.4h33.7c4.6,0,8.4,3.8,8.4,8.4v134.9c0,4.6-3.8,8.4-8.4,8.4H60.6c-4.6,0-8.4-3.8-8.4-8.4V94.3c0-4.6,3.8-8.4,8.4-8.4h33.7v-8.4H60.6c-9.3,0-16.9,7.5-16.9,16.9v134.9c0,9.3,7.5,16.9,16.9,16.9h134.9c9.3,0,16.9-7.5,16.9-16.9V94.3C212.3,85,204.7,77.4,195.4,77.4z M97.3,50.9l26.5-26.5v133.1c0,2.3,1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2V24.4l26.5,26.5c0.8,0.8,1.9,1.2,3,1.2s2.2-0.4,3-1.2c1.6-1.6,1.6-4.3,0-5.9L131,11.2c-1.6-1.6-4.3-1.6-5.9,0L91.3,44.9c-1.6,1.6-1.6,4.3,0,5.9C93,52.6,95.6,52.6,97.3,50.9z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.758279922ed69e1aa9009463b4067c1d.svg";
export { ForwardRef as ReactComponent };